import React from 'react'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Can } from '@morningtrain/react-auth'
import { PaginationFilter, StaticFilter } from '@morningtrain/react-filters'
import Permissions from 'services/Permissions'
import { SwitchFilter } from 'support/filters'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import ContractSmartview from 'pages/app/hr/employments/smartviews/ContractSmartview'

export default function UserContracts ({ userId = null }) {
  if (!userId) {
    return null
  }

  return (
    <Can permission={Permissions.CONTRACTS_VIEW}>
      <Translator namespace='hr.contracts'>
        <Collection resourceName='employments.contracts' operationName='index'>
          <StaticFilter name='user_id' value={userId} />
          <Can permission={Permissions.CONTRACTS_MANAGE}>
            <MountSmartviewOnSelection smartview={<ContractSmartview create={false} />} replace={false} />
          </Can>

          <UI.Card>
            <UI.CardHeader>
              <UI.SecondaryHeading>
                <Translation name='titles.contracts' />
              </UI.SecondaryHeading>
              <div>
                <SwitchFilter
                  name="focused_status"
                  enum="focused_contract_status"
                  defaultValue={null}
                  only={['completed', 'employed', 'failed', 'pending']}
                  placeholder={<Translation name="generic.all"/>}
                />
              </div>
            </UI.CardHeader>
            <Table>
              <Columns.Text
                name='department_name'
                label={<Translation name='columns.department.label' />}
              />
              <Columns.Text
                name='template_name'
                label={<Translation name='columns.contract_template.label' />}
                sortSlug='sortByTemplateName'
              />
              <Columns.Text
                name='employment_type'
                label={<Translation name='columns.employment_type.label' />}
              />
              <Columns.Enum
                name='detailed_status'
                label={'status'}
                enum='detailed_contract_status'
              />
              <Columns.DateTime
                name='updated_at'
                alignment='right'
                label={<Translation name='columns.updated_at.label' />}
              />
            </Table>
            <PaginationFilter />
          </UI.Card>
        </Collection>
      </Translator>
    </Can>
  )
}
